export enum CrudOperation {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
  preview = 'preview',
}
